import queryString from 'querystring';
import { truncate, findIndex } from 'lodash';
import portalCommunication from '@3plearning/mathletics-portal-communication-service';


export function handleDefaults(defaultObj, dynamicObj) {
    for (const key in dynamicObj) {
        defaultObj[key] = dynamicObj[key];
    }
    return defaultObj;
}

export function log() {}

export function getTruncatedName(name, type) {
    let length = 20;
    switch (type) {
    case 'selectOptionName':
    case 'className':
    case 'groupName':
        length = 50;
        break;
    case 'schoolName':
        length = 20;
        break;
    case 'activityName':
        length = 39;
        break;
    default:
        length = 20;
    }
    length += 3;
    const truncName = truncate(name, {
        length,
        separator: ''
    });
    return truncName;
}


// region student-reducer helper functions
export function truncateName(name) {
    if (name.length > 70) {
        name = `${name.substring(0, 42)}...`;
    }
    return name;
}

export function filterStudentList(state, payload, students, selectAll, classGroup) {
    const newState = {
        ...state
    };
    const student = payload.student;
    newState[classGroup].map((item) => {
        if (item.userProfileId === payload.student.userProfileId) {
            item = {
                ...student
            };
            if (item.selected) {
                newState[students].push(item);
            }
        }
        return item;
    });
    if (!student.selected) {
        newState[students] = newState[students].filter(removedListItems =>
            removedListItems.userProfileId !== student.userProfileId);
    }
    newState[selectAll] = newState[students].length === newState[classGroup].length;
    return newState;
}

export function disableAvailableStudents(students, classGroupStudents) {
    const finalValue = [];
    students.map((studentItem) => {
        studentItem.disabled = false;
        classGroupStudents.map((classItem) => {
            if (studentItem.userProfileId === classItem.userProfileId) {
                studentItem.disabled = true;
            }
            return true;
        });
        finalValue.push(studentItem);
        return true;
    }
    );
    return finalValue;
}

export function toggleSelected(list, value) {
    return list.map((item) => {
        item.selected = value;
        if (item.disabled) {
            item.selected = false;
        }
        return item;
    });
}

// endregion

// region students helper
export const moveCopyDisableButton = (availableSelectedStudents, availableClassId, selectedClassId,
    availableClassGroupId, selectedGroupId) => {
    let checker = false;
    if (availableSelectedStudents.length <= 0) {
        checker = true;
    }
    if (parseInt(availableClassId, 10) === parseInt(selectedClassId, 10) &&
        parseInt(availableClassGroupId, 10) === parseInt(selectedGroupId, 10)) {
        checker = true;
    }
    return checker;
};
// endregion

// region entry app functions
export function getLocale() {
    const queryParams = window.location.search;
    const query = queryParams.replace('?', '');
    const params = queryString.parse(query);
    let locale = params.locale;
    const supportedLocales = ['en', 'es'];

    if (supportedLocales.indexOf(locale) !== -1) {
        return String(locale).toLowerCase();
    }

    switch (String(locale).substr(0, 2)) {
    case 'es':
        locale = 'es';
        break;
    default:
        locale = 'en';
    }

    return locale;
}
// endregion
export function findItemWithIndex(itemList, itemName, itemValue) {
    const num = (itemList || []).length;
    let selectedItem;
    if (num > 1) {
        let myIndex = findIndex(itemList, (item) => {
            let bool = false;
            if (item[itemName] === itemValue) {
                bool = true;
            }
            return bool;
        }) || 0;
        myIndex = (myIndex < 0) ? 0 : myIndex;
        const myItem = itemList[myIndex];
        selectedItem = { ...myItem, displaySelect: true, indexValue: myIndex };
    } else if (num === 1) {
        selectedItem = { ...itemList[0], displaySelect: false, indexValue: 0 };
    } else {
        selectedItem = {};
    }

    return selectedItem;
}

// region student-actions function
export function findItem(list, searchValue, property) {
    property = property || 'id';
    if (!list) {
        return null;
    }
    for (let i = 0; i < list.length; i += 1) {
        if (list[i][property] === searchValue) {
            return list[i];
        }
    }
    return null;
}
// endregion

export function navigateToModule(type, params) {
    // eslint-disable-next-line no-underscore-dangle
    if (window._env_ && window._env_.NavigationModules) {
        // eslint-disable-next-line no-underscore-dangle
        const config = window._env_.NavigationModules;
        if (!config) {
            return;
        }
        const navModuleId = config[type];
        if (!navModuleId) {
            return;
        }
        portalCommunication.requestModuleChange(navModuleId, {
            ...params
        });
    }
}

/** *
 *  scroll window to force render
 * react-table doesn't render when changing selection
 * We need find another way to force scroll
 * */
export function forceRender() {
    window.scrollBy(0, 10);
    window.scrollBy(0, -10);
}



// WEBPACK FOOTER //
// ./helpers/utils.js